import { get } from '@/util/auth'

import { API_ROUTE_STATS } from './apiRoutes'

type Stats = {
  deviceOrders: number
  subscriptionOrders: number
  customers: number
  ecomOrders: number
  ecomOrdersCost: number
  tradeInOrders: number
}
const IS_NEW_BACKEND_API = true
export const statsResources = {
  get: () => get<Stats>(API_ROUTE_STATS, IS_NEW_BACKEND_API),
}
